import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-br from-red-600 to-red-700 rounded-lg flex items-center justify-center">
              <i className="ri-bank-card-line text-white text-lg"></i>
            </div>
            <span className="text-xl font-bold text-gray-900">クレカスタート</span>
          </Link>

          <nav className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-sm text-gray-700 hover:text-red-600 transition-colors whitespace-nowrap">
              ホーム
            </Link>
            <Link to="/ranking" className="text-sm text-gray-700 hover:text-red-600 transition-colors whitespace-nowrap">
              人気ランキング
            </Link>
            <Link to="/comparison" className="text-sm text-gray-700 hover:text-red-600 transition-colors whitespace-nowrap">
              比較一覧
            </Link>
            <Link to="/diagnosis" className="text-sm font-semibold text-red-600 whitespace-nowrap">
              無料診断
            </Link>
          </nav>

          <Link
            to="/ranking"
            className="hidden md:block bg-red-600 text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-red-700 transition-colors whitespace-nowrap"
          >
            人気ランキングを見る
          </Link>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center"
            aria-label="メニュー"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-white z-40 overflow-y-auto">
          <nav className="flex flex-col p-4 gap-2">
            <Link
              to="/"
              className="px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              ホーム
            </Link>
            <Link
              to="/ranking"
              className="px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              人気ランキング
            </Link>
            <Link
              to="/comparison"
              className="px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              比較一覧
            </Link>
            <Link
              to="/diagnosis"
              className="px-4 py-3 font-semibold text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              無料診断
            </Link>
            <Link
              to="/ranking"
              className="mt-4 bg-red-600 text-white px-6 py-3 rounded-full text-center font-semibold hover:bg-red-700 transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              人気ランキングを見る
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
